import React from "react"
import { Link } from "gatsby"

const Function = () => {
  return (
    <div className='banner'>
      <img className='bannerImage' src='banner.jpg' alt='Onur Tesisat Banner' />
      <div className='wrapper'>
        <h1 className='bannerTitle'>
          Profesyonel <br />
          <strong>Su Tesisatı Hizmetleri</strong>
        </h1>
        <h2 className='bannerText'>
          <strong>Su Tesisatı</strong> Sorunlarınıza <br /> Kalıcı ve Kaliteli
          Hizmet Sunuyoruz!
        </h2>
        <div className='bannerButtons'>
          <Link className='button' to='/iletisim'>
            İLETİŞİM
          </Link>
          <Link className='button2' to='/hizmetler'>
            HİZMETLER
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Function
